import { Directive, Inject, AfterViewInit } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwEnvDetector
 * @module mw.components.envDetector
 * @restrict A
 *
 * @description
 * `mw-env-detector` is an attribute directive that will add OS, Browser and Device classes to an element.
 *
 * 3 classes will be added to the element,
 * * 'os-{os name}'
 * * 'browser-{browser name}'
 * * 'device-{device name}'
 *
 *
 * @usage
 * <hljs hljs-language="html">
 * <div mw-env-detector>
 * </div>
 * </hljs>
 */
@Directive({
  selector: '[mwEnvDetector]'
})
export class EnvDetectorDirective implements AfterViewInit {

    constructor(@Inject('$element') private $element,
                @Inject('mwEnvDetector') private mwEnvDetector) {
        'ngInject';
    }

    ngAfterViewInit() {
        this.mwEnvDetector.addEnvClassesToElement(this.$element);
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/env-detector/env-detector.directive.ts